import { EnergyProvider } from "./energy/EnergyProvider";

export const DataProvider = ({ children }) => (
  
        <EnergyProvider>
          {children}
        </EnergyProvider>
);